import { render } from "./CookingTab.vue?vue&type=template&id=36f86d72&scoped=true"
import script from "./CookingTab.vue?vue&type=script&lang=js"
export * from "./CookingTab.vue?vue&type=script&lang=js"

import "./CookingTab.vue?vue&type=style&index=0&id=36f86d72&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f86d72"]])

export default __exports__